import React from 'react';
import { services } from '../mock';
import { Card, CardContent } from './ui/card';
import * as Icons from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const ServicesSection = () => {
  return (
    <section id="services" className="py-10 md:py-20 bg-white font-['Poppins']">
      <div className="container mx-auto px-4">
        {/* Header - 24px gap between title and description */}
        <div className="mb-10 text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-[#153254]">
            Nos Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Des prestations de qualité professionnelle adaptées à tous vos besoins du quotidien
          </p>
        </div>

        {/* Grid with 8px based gaps */}
        <div className="relative">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mb-10">
            {services.map(service => {
              const IconComponent = Icons[service.icon];
              return (
                <Card 
                  key={service.id}
                  className="group hover:shadow-2xl transition-all duration-300 border-0 overflow-hidden bg-white rounded-2xl shadow-lg h-full"
                >
                  {/* Image header */}
                  <Link 
                    to={`/service/${service.id}`}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div className="relative h-32 md:h-48 overflow-hidden cursor-pointer">
                      <img 
                        src={service.image} 
                        alt={service.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                      <div className="absolute bottom-3 left-3 md:bottom-4 md:left-4">
                        <div className="w-10 h-10 md:w-12 md:h-12 bg-white rounded-xl flex items-center justify-center shadow-lg">
                          {IconComponent && <IconComponent className="h-5 w-5 md:h-6 md:w-6 text-[#0A2320]" />}
                        </div>
                      </div>
                    </div>
                  </Link>
                  
                  <CardContent className="p-4 md:p-5 bg-white">
                    <Link 
                      to={`/service/${service.id}`}
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <h3 className="font-bold text-base md:text-xl mb-2 text-[#153254] hover:text-[#0A2320] transition-colors line-clamp-1">
                        {service.title}
                      </h3>
                    </Link>
                    <p className="text-gray-600 text-xs md:text-sm mb-4 leading-relaxed line-clamp-2 md:line-clamp-3">
                      {service.description}
                    </p>
                    
                    {/* Bouton "En savoir plus" */}
                    <Link 
                      to={`/service/${service.id}`}
                      onClick={() => window.scrollTo(0, 0)}
                      className="block"
                    >
                      <Button 
                        variant="outline" 
                        className="w-full border-2 border-[#0A2320] text-[#0A2320] hover:bg-[#0A2320] hover:text-white font-semibold rounded-xl transition-all text-xs md:text-sm py-2 md:py-2.5"
                      >
                        En savoir plus
                        <ArrowRight className="ml-1 md:ml-2 h-3 w-3 md:h-4 md:w-4" />
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              );
            })}
          </div>
          
          {/* Scroll indicator - Mobile only */}
          <div className="flex justify-center md:hidden mb-6">
            <div className="flex items-center gap-2 text-gray-400 text-xs">
              <span>Faites défiler pour voir plus</span>
              <svg className="w-4 h-4 animate-bounce-x" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </div>
          </div>
        </div>

        {/* CTA Button - aligned with grid */}
        <div className="text-center">
          <Link to="/devis-premium" className="inline-block w-full sm:w-auto">
            <Button 
              className="w-full sm:w-auto bg-[#0A2320] hover:bg-[#0d2e2a] text-white font-semibold text-sm md:text-base px-6 py-3 md:px-8 md:py-4 shadow-xl rounded-xl transition-all hover:-translate-y-1"
            >
              Demander un devis personnalisé
              <ArrowRight className="ml-2 h-4 w-4 md:h-5 md:w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
